/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon64Regular = forwardRef('ArrowShapeTriangleADownIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51.673 13c4.352 0 6.98 4.814 4.627 8.474L36.627 52.077c-2.165 3.368-7.088 3.368-9.253 0L7.7 21.474C5.347 17.814 7.975 13 12.327 13h39.346Zm2.103 6.852c1.07-1.664-.125-3.852-2.103-3.852H12.328c-1.978 0-3.173 2.188-2.103 3.852l19.673 30.603c.984 1.53 3.222 1.53 4.206 0l19.673-30.603Z" })));
});
